import React from "react";

const AppML_Architecture = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Architecture</h1>
      <p>This is the AppML Architecture page content.</p>
    </div>
  );
};

export default AppML_Architecture;
